import { render, staticRenderFns } from "./OcrCommonConfig.vue?vue&type=template&id=111b21e4&scoped=true"
import script from "./OcrCommonConfig.vue?vue&type=script&lang=js"
export * from "./OcrCommonConfig.vue?vue&type=script&lang=js"
import style0 from "./OcrCommonConfig.vue?vue&type=style&index=0&id=111b21e4&prod&scoped=true&lang=css"
import style1 from "./OcrCommonConfig.vue?vue&type=style&index=1&id=111b21e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111b21e4",
  null
  
)

export default component.exports